
export const validateJWTToken = (token) => {
    const result = {
        isValid: false,
        isExpired: true,
        payload: null,
        timeUntilExpiry: null,
        error: null
    };

    if (!token || typeof token !== 'string') {
        result.error = 'Token inválido ou não fornecido';
        return result;
    }

    // Verifica se o token tem o formato correto (3 partes separadas por ponto)
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
        result.error = 'Formato de token JWT inválido';
        return result;
    }

    try {
        // Decodifica o payload
        const payload = JSON.parse(atob(tokenParts[1]));
        result.payload = payload;

        // Verifica se existe timestamp de expiração
        if (!payload.exp) {
            result.error = 'Token não possui data de expiração';
            return result;
        }

        // Calcula se está expirado
        const currentTime = Math.floor(Date.now() / 1000);
        const expirationTime = payload.exp;
        const timeLeft = expirationTime - currentTime;

        result.isExpired = timeLeft <= 0;
        result.isValid = !result.isExpired;
        result.timeUntilExpiry = Math.max(0, timeLeft);

        return result;
    } catch (error) {
        result.error = `Erro ao decodificar token: ${error.message}`;
        return result;
    }
};

// Função para verificar se o token expira em breve (útil para renovação automática)
export const isTokenExpiringSoon = (token, thresholdMinutes = 5) => {
    const validation = validateJWTToken(token);

    if (!validation.isValid) return false;

    const thresholdSeconds = thresholdMinutes * 60;
    return validation.timeUntilExpiry <= thresholdSeconds;
};